<template>
    <div class="sale-card-seller fadeInRight">
        <div class="title-box clearfix">
            <span class="m-title">销售员</span>
            <el-form inline ref="sellerForm" v-model="sellerFormData" class="right themed-form search-form" style="height: auto;line-height: 40px;">
                <el-form-item>
					<el-button icon="el-icon-circle-plus" class="themed-button" type="info" @click="add()">新增</el-button>
				</el-form-item>
            </el-form>
        </div>

         <div class="content-box">
            <el-table
                border
                ref="table"
                stripe
                :max-height="maxTableHeight"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                >
                <el-table-column
                    show-overflow-tooltip
                    prop="saleName"
                    label="销售名称"
                    min-width="150"
                    >
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="wechatNum"
                    label="企业微信"
                    min-width="150"
                    >
                </el-table-column>

                <el-table-column
                    show-overflow-tooltip
                    prop="department"
                    label="销售部门"
                    min-width="150"
                    >
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    label="创建时间"
                    min-width="150"
                    >
                    <template slot-scope="scope">
                        <span v-if="scope.row.updateTime">{{formatTime(scope.row.updateTime)}}</span>
                    </template>
                </el-table-column>
   
            </el-table>
            <el-pagination :current-page.sync="page"  :page-sizes="[10,15,25,100]" :page-size="pageSize" style="text-align: left;margin-top: 20px;"
			 background layout="total,sizes,prev, pager, next,jumper" :total="total" @size-change="handleSizeChange" @current-change="onPageChange"></el-pagination>
        </div>

        <el-dialog title="新增设置" :visible.sync="addDialogFormVisible" width="600px" :destroy-on-close='true'>
            <el-form :model="addForm" :rules="rules" ref="addForm">
                <el-form-item label="名称" :label-width="formLabelWidth" prop="saleName">
                    <el-input v-model="addForm.saleName" autocomplete="off" style="width:300px"></el-input>
                </el-form-item>

                <el-form-item label="企业微信" :label-width="formLabelWidth" prop="wechatNum">
                    <el-input v-model="addForm.wechatNum" autocomplete="off" style="width:300px"></el-input>
                </el-form-item>

                <el-form-item label="部门" :label-width="formLabelWidth" prop="departmentId">
                    <search-select :optionsMetaAll="departmentOptions" v-model="addForm.departmentId" style="width:170px"></search-select>
                </el-form-item>

                

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="themed-button" type="info" @click="sureAdd('addForm')">确 定</el-button>
                <el-button class="themed-button" type="primary" @click="addDialogFormVisible = false">关 闭</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import SearchSelect from '@/components/SearchSelect.vue'
import resize from '@/mixins/resize.js'
import {sellerList,departmentOptionsList,addSeller} from "@/api/saleCardBatch.js"
import Utils from '@/utils/utils.js'
export default {
    name:'seller',
    components:{SearchSelect},
    mixins:[resize],
    data(){
        return {
            departmentOptions:[{label:"全部",value:""}],
            sellerFormData:{},
            departmentList:[],
            tableData:[],
            page:1,
            pageSize:15,
            total:0,
            addDialogFormVisible:false,
            addForm:{
                saleName:'',
                wechatNum:'',
                departmentId:'',
            },
            formLabelWidth:'150px',
            rules:{
                saleName:[
                    {required: true, message: '请输入名称', trigger: 'blur'}
                ],
                 departmentId:[
                    {required: true, message: '请选择部门', trigger: 'blur'}
                ],
            },
        }
    },
    created(){
        this.getSellerList() 
        this.getDepartmentOptions()
    },
    methods:{
        getDepartmentOptions(){
            departmentOptionsList().then(res=>{
                 let arrList =[{label:"全部",value:""}]
                 res.forEach(element => {
                     arrList.push({label:element.departmentName,value:element.id})
                 })               
                 this.departmentOptions=arrList
             })
        },
        getSellerList(){
            let params={
                pageNo:this.page,
                pageSize:this.pageSize
            }
            sellerList(params).then(res=>{
                this.tableData = res.rows
                this.total = res.count
            })
        },
        formatTime(time){
             return Utils.dateFormat('YYYY-mm-dd HH:MM:SS',new Date(time))
        },
        add(){
            this.addDialogFormVisible=true
            this.$nextTick(()=>{
                this.$refs['addForm'].resetFields();
            })
        },
        sureAdd(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    addSeller(this.addForm).then(res=>{
                        this.$message({
                            showClose: true,
					        message: '添加成功',
					        type: 'success',
							center: true
                        })
                        this.addDialogFormVisible=false
                        this.addForm.departmentId = ''
                        this.getSellerList() 
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        onPageChange(page){
            this.page = page
            this.getSellerList()
		},
		handleSizeChange(size){
            this.pageSize = size
            this.getSellerList()
        },
    }
}
</script>